import { useCallback, useMemo, useReducer } from "react";
import reduceProcessedCalls from "./reducer";
import { initialState } from "./initialState";
import { getCallQueueStateViewModel, getQueuedAtEpoch } from "../utils";
import { ProcessedCallActions } from "./action";

export default function useProcessedCallsStore() {
  const [state, dispatch] = useReducer(reduceProcessedCalls, initialState);

  const updateCallQueueStats = useCallback(function (state) {
    const callQueueStateViewModel = getCallQueueStateViewModel(state);
    dispatch({
      type: ProcessedCallActions.SET_STATE,
      payload: callQueueStateViewModel,
    });
  }, []);

  const updateIsLoading = useCallback(function (isLoading) {
    dispatch({
      type: ProcessedCallActions.SET_LOADING,
      payload: { isLoading },
    });
  }, []);

  const updateQueuedAt = useCallback(function (queuedAt) {
    dispatch({
      type: ProcessedCallActions.UPDATE_QUEUED_AT,
      payload: { queuedAt, queuedAtTimestamp: getQueuedAtEpoch(queuedAt) },
    });
  }, []);

  const value = useMemo(
    function () {
      return {
        state,
        updateCallQueueStats,
        updateIsLoading,
        updateQueuedAt,
      };
    },
    [state, updateCallQueueStats, updateIsLoading, updateQueuedAt]
  );

  return value;
}
